import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as legalEntitiesState from '../reducers';
import * as legalEntitiesReducer from '../reducers/create-businesses.reducer';

export const selectCreatedLegalEntityBusiness = createSelector(
  legalEntitiesState.getLegalEntitiesCreatedBusinessState,
  legalEntitiesReducer.getCreatedLegalEntity
);
